// extracted by mini-css-extract-plugin
export default {"wrap":"ShippingAndReturns_wrap__79gVQ","row":"ShippingAndReturns_row__JbtJG"};